<!--
 * @Description: 送检
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 09:43:45
-->
<template>
    <CommonCheckout :dataTypeId='9' />
</template>

<script>
import CommonCheckout from './commoncheckout'
export default {
  components: {
    CommonCheckout,
  },
  data() {
      return {
      }
  },
  methods: {
  },
};
</script>
